var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21.7072 6.20718L8.00008 19.9143L2.29297 14.2072L3.70718 12.793L8.00008 17.0859L20.293 4.79297L21.7072 6.20718Z"}));
}

Tick.defaultProps = {"width":"24","height":"25","viewBox":"0 0 24 25","fill":"none"};

module.exports = Tick;

Tick.default = Tick;
